import { ComponentProps, ComponentType, FunctionComponent } from 'react';
import connect, { WithAuthProps } from './withAuth.state';

export const withAuth = <TProps extends {}>(Component: ComponentType<TProps>) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const WrappedComponent = connect(Component as any);

  WrappedComponent.displayName = `WithAuth(${WrappedComponent.displayName ||
    'Component'})`;

  return WrappedComponent as FunctionComponent<
    Omit<ComponentProps<typeof Component>, keyof WithAuthProps>
  >;
};
